import { useQuery } from '@tanstack/react-query';
import AddressService from '@/services/addressService';

export const useAddress = (country = 'BR') => {
  const addressService = new AddressService(country);

  const useStates = () => useQuery({
    queryKey: ['address', country, 'states'],
    queryFn: () => addressService.getStates(),
    staleTime: Infinity,
  });

  const useCities = (stateId) => useQuery({
    queryKey: ['address', country, 'state', stateId, 'cities'],
    queryFn: () => addressService.getCitiesByState(stateId),
    enabled: !!stateId,
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  const useNeighborhoods = (cityId) => useQuery({
    queryKey: ['address', country, 'city', cityId, 'neighborhoods'],
    queryFn: () => addressService.getNeighborhoodsByCity(cityId),
    enabled: !!cityId,
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  const useLocation = (zipcode) => useQuery({
    queryKey: ['address', country, 'zipcode', zipcode],
    queryFn: () => addressService.getLocationByZipcode(zipcode),
    enabled: !!zipcode && addressService.validateZipcode(zipcode),
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return {
    useStates,
    useCities,
    useNeighborhoods,
    useLocation,
    validateZipcode: (zip) => addressService.validateZipcode(zip),
    getZipcodeMask: () => addressService.getZipcodeMask(),
  };
};
